export default __webpack_public_path__ + "static/media/aboutBanner.bd61ae17.jpg";